module.exports = __webpack_public_path__ + "img/智慧校园综合管理平台.d0259c42.png";